export default "__VITE_ASSET__Bq72fv4___"